import { TourKeys } from '@cast/constants';
import { useClustersSummary as useClustersSummaryQuery } from '@cast/shared-cost-data-access';

import { useAbility } from '@cast/shared-ability-data-access';
import { useTourStepId } from 'core/tour-v2/hooks/useTourStepId';

export const useClustersSummary = () => {
  const ability = useAbility();
  const tourStepKey = useTourStepId(TourKeys.OpinionatedPlatform);

  return useClustersSummaryQuery(tourStepKey, (clusterId) =>
    ability.can('view', 'Clusters', { clusterId })
  );
};
